<template>
    <div class="cbg-content">
        <div class="cbg-top">
            <div v-for="(item, a) in validDefaultData" :key="a">
                <div class="contentCenterTitle">{{ item.value1 }}</div>
                <div class="dl">
                    <div class="centerNum" v-for="(item, i) in +item.value3" :key="i"><span>{{ getNum(a, i) }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="bar_bg"></div>
        <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import * as methods from './method.js'
import 'echarts-gl';
require('echarts/lib/chart/bar.js');
require('echarts/lib/component/title.js');
require('echarts/lib/component/tooltip.js');
export default {
    name: "template.scope114",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '数据统计', value2: '11566', value3: '6', value4: '4月', value5: '系列一', value6: '10', value7: '系列二', value8: '20', value9: '%' },
                { value1: '数据统计', value2: '42', value3: '3', value4: '5月', value5: '系列一', value6: '20', value7: '系列二', value8: '30' },
                { value1: '数据统计', value2: '156', value3: '3', value4: '6月', value5: '系列一', value6: '30', value7: '系列二', value8: '40' },
                { value1: '数据统计', value2: '432', value3: '3', value4: '7月', value5: '系列一', value6: '40', value7: '系列二', value8: '50' },
                { value1: '', value2: '', value3: '', value4: '8月', value5: '系列一', value6: '50', value7: '系列二', value8: '60' }
            ],
            valueMap: [
                { name: '概览名称', key: "value1" },
                { name: '概览数值', key: "value2" },
                { name: '概览位数', key: "value3" },
                { name: "图表名称", key: "value4" },
                { name: '图例1', key: 'value5' },
                { name: '柱图1数值', key: 'value6' },
                { name: '图例2', key: 'value7' },
                { name: '柱图2数值', key: 'value8' },
                { name: '单位', key: 'value9' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
            numTotals: [], // 动态存储 numtotal 的数组
            timers: [], // 动态存储定时器的数组
            paddedNumCache: [], // 存储补零后的字符串结果
            validDefaultData: [], // 存储符合位数限制的数据
        };
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata() {
            this.setdata()
            this.DrawEcharts();
        }
    },
    methods: {
        ...methods,
        setdata() {
            let totalDigits = 0;
            let validIndex = 0;
            // 找出符合 18 位限制的数据项
            for (let i = 0; i < this.defaultdata.length; i++) {
                const currentDigits = +this.defaultdata[i].value3;
                if (totalDigits + currentDigits <= 18) {
                    totalDigits += currentDigits;
                    validIndex = i;
                } else {
                    break;
                }
            }
            // 截取符合条件的数据项
            this.validDefaultData = this.defaultdata.slice(0, validIndex + 1);

            if (this.validDefaultData && this.validDefaultData.length) {
                this.numTotals = this.validDefaultData.map(() => 0);
                this.paddedNumCache = this.validDefaultData.map((item) => {
                    let numStr = item.value2.toString();
                    // 如果 value2 的位数超过 value3，只取前 value3 位
                    if (numStr.length > +item.value3) {
                        numStr = numStr.slice(0, +item.value3);
                    }
                    return this.numreduce(numStr, +item.value3);
                }); // 初始化缓存数组，处理后根据 value2 和 value3 补零
                this.validDefaultData.forEach((item, i) => {
                    item.value = +item.value2 || 0;
                });
                this.validDefaultData = this.validDefaultData.filter(item => item.value3 && +item.value3 > 0)
            }
        },

        numreduce(num, len) {
            let start = "";
            let numend = num.toString();
            if (numend.length < len) {
                for (let i = 0; i < len - numend.length; i++) {
                    start = start + "0";
                }
            }
            return start + numend;
        },
        indexSumnew(index) {
            if (+this.validDefaultData[index].value !== +this.numTotals[index]) {
                let num = this.numreduce(
                    +this.validDefaultData[index].value,
                    +this.validDefaultData[index].value3
                ).split("");
                let strnum = this.numreduce(
                    +this.numTotals[index],
                    +this.validDefaultData[index].value3
                ).split("");
                strnum.forEach((del, a) => {
                    if (+del < +num[a]) {
                        strnum[a] = +del + 1;
                    }
                });
                this.numTotals[index] = strnum.join("");
                this.paddedNumCache[index] = this.numreduce(
                    this.numTotals[index],
                    +this.validDefaultData[index].value3
                ); // 更新缓存
            } else {
                clearInterval(this.timers[index]);
                this.timers[index] = null;
                setTimeout(() => {
                    this.numTotals[index] = 0;
                    this.paddedNumCache[index] = "0".repeat(
                        +this.validDefaultData[index].value3
                    ); // 重置缓存
                    this.timers[index] = setInterval(() => {
                        this.indexSumnew(index);
                    }, 300);
                }, 5000);
            }
        },
        startTimers() {
            this.timers.forEach((timer) => {
                if (timer) {
                    clearInterval(timer);
                }
            });
            this.timers = [];
            this.validDefaultData.forEach((_, index) => {
                this.timers[index] = setInterval(() => {
                    this.indexSumnew(index);
                }, 300);
            });
        },
        getNum(a, i) {
            // 检查索引是否越界
            if (a >= this.paddedNumCache.length) {
                return "0";
            }
            // 从缓存中获取补零后的字符串
            const paddedNum = this.paddedNumCache[a];
            return paddedNum[i] || "0";
        },
        DrawEcharts() {
            clearInterval(this.timer);
            this.timer = null;
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.cmain1);
            let data1 = [];
            let data2 = [];
            let top = [];
            let legend = [];
            let unit = this.defaultdata[0].value9 || ''
            this.defaultdata.forEach((item, i) => {
                if (item.value5 && item.value6) {
                    const vdata1 = { name: item.value5, value: item.value6 };
                    data1.push(vdata1);
                }
                if (item.value7 && item.value8) {
                    const vdata2 = { name: item.value7, value: item.value8 };
                    data2.push(vdata2);
                }
                top.push((+item.value6 || 0) + (+item.value8 || 0));
                if (i == 0) {
                    if (item.value5) {
                        legend.push({
                            top: "2%",
                            right: "50%",
                            itemHeight: 12, //图例的高度  文字左边那个
                            itemWidth: 10,
                            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                            data: [{ name: item.value5, icon: "rect" }],
                        });
                    }
                    if (item.value7) {
                        legend.push({
                            top: "2%",
                            left: "50%",
                            itemHeight: 12, //图例的高度  文字左边那个
                            itemWidth: 10,
                            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                            data: [{ name: item.value7, icon: "rect" }],
                        });
                    }
                }
            });
            const xAxis = this.defaultdata.map((item) => {
                return item.value1;
            });
            const percent = (7 / xAxis.length) * 100;
            let zoom = [
                {
                    id: "scope114", // 唯一的id
                    xAxisIndex: [0], //滑动条为竖
                    type: 'slider',
                    moveHandleSize: 0,
                    showDetail: false, //关闭：拖拽时候显示详细数值信息。	
                    dataBackground: {
                        show: false,
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    selectedDataBackground: {
                        lineStyle: {
                            opacity: 0,
                        },
                        areaStyle: {
                            opacity: 0,
                        },
                    },
                    backgroundColor: "transparent",
                    fillerColor: "rgba(0,0,0,.2)",
                    borderColor: "transparent",
                    start: 0,
                    brushSelect: false,
                    end: percent
                },
            ];

            var barWidth = 28
            const defaultdata = this.defaultdata;
            let Toption = {
                title: [
                    {
                        text: unit,
                        top: "0",
                        left: "0",
                        textStyle: {
                            color: "#979AA0",
                            fontSize: 12,
                        },
                    },
                ],
                grid: {
                    left: "10px",
                    right: "10px",
                    bottom: "0px",
                    top: "60px",
                    containLabel: true,
                },
                tooltip: {
                    formatter: function (params) {
                        let name1 = "";
                        let name2 = "";
                        if (defaultdata[0].value5 && defaultdata[0].value6) {
                            name1 =
                                "名称：" +
                                params.name +
                                "<br/>" +
                                defaultdata[0].value5 +
                                "：" +
                                data1[params.dataIndex].value;
                        }
                        if (defaultdata[0].value7 && defaultdata[0].value8) {
                            name2 =
                                "<br/>" +
                                defaultdata[0].value7 +
                                "：" +
                                data2[params.dataIndex].value;
                        }
                        return name1 + name2;
                    },
                },
                legend: [...legend],
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: this.defaultdata.map((item) => {
                        return item.value4;
                    }),
                    axisLabel: {
                        interval: 0,
                        width: 45,
                        overflow: 'truncate',
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "14",
                            lineHeight: 16,
                        },

                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    name: "单位",
                    splitNumber: 4, // 设置 Y 轴分割线的数量
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#15205B",
                        },
                    },
                    // nameTextStyle: {
                    //     color: "#B0B5BB",
                    //     nameLocation: "start",
                    //     padding: [0, 0, 0, -40]
                    // },
                    splitLine: {
                        show: false,
                        lineStyle: {
                            color: "rgba(135,140,147,1)", //左侧显示线
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                    axisTick: {
                        show: true,
                    },
                    axisLabel: {
                        formatter: "{value}",
                        textStyle: {
                            color: "#c9c9c9",
                            fontSize: 10,
                        },
                    },
                },
                series: [
                    //center zz
                    {
                        type: "pictorialBar",
                        symbol: "diamond",
                        symbolSize: [barWidth, 10],
                        symbolOffset: [-17, -5.5],
                        symbolPosition: "end",
                        z: 20,
                        color: "#078eda",
                        data: data1.map((item) => {
                            return item.value;
                        }),
                    },
                    {
                        data: data2.map((item) => {
                            return item.value;
                        }),
                        type: "pictorialBar",
                        symbol: "diamond",
                        name: this.defaultdata[0].value7 || "",
                        symbolSize: [barWidth, 10],
                        symbolOffset: [17, -5.5],
                        color: "#11e3e2",
                        z: 20,
                        symbolPosition: "end",
                    },
                    // bottom
                    {
                        name: this.defaultdata[0].value5 || "",
                        type: "bar",
                        barWidth: barWidth,
                        itemStyle: {
                            normal: {
                                opacity: 1,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: "#0980f8",
                                    },
                                    {
                                        offset: 0.49,
                                        color: "#0980f8",
                                    },
                                    {
                                        offset: 0.5,
                                        color: "#0980f8",
                                    },
                                    {
                                        offset: 0.51,
                                        color: "#095baf",
                                    },
                                    {
                                        offset: 1,
                                        color: "#095baf",
                                    },
                                ]),
                                barBorderRadius: 0,
                            },
                        },
                        data: data1.map((item) => {
                            return item.value;
                        }),
                    },
                    // top
                    {
                        data: data2.map((item) => {
                            return item.value;
                        }),
                        type: "bar",
                        name: this.defaultdata[0].value7 || "",
                        barWidth: barWidth,
                        itemStyle: {
                            normal: {
                                opacity: 1,
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                    {
                                        offset: 0,
                                        color: "#07a1a3",
                                    },
                                    {
                                        offset: 0.49,
                                        color: "#07a1a3",
                                    },
                                    {
                                        offset: 0.5,
                                        color: "#07a1a3",
                                    },
                                    {
                                        offset: 0.51,
                                        color: "#0d4b4d",
                                    },
                                    {
                                        offset: 1,
                                        color: "#0d4b4d",
                                    },
                                ]),
                                barBorderRadius: 0,
                            },
                        },
                    },
                ],
                dataZoom: xAxis.length > 7 ? zoom : [],
            };


            TmyChart.on("legendselectchanged", (data) => {
                let datamap = Object.keys(data.selected);
                if (
                    data.selected[datamap[0]] == false &&
                    data.selected[datamap[1]] == false
                ) {
                    //1,2都不选
                    Toption.series[0].data = [];
                    Toption.series[1].data = [];
                    Toption && TmyChart.setOption(Toption);
                } else if (
                    data.selected[datamap[0]] == true &&
                    data.selected[datamap[1]] == false
                ) {
                    //1选2不选}
                    Toption.series[0].data = data1;
                    Toption.series[1].data = [];
                    Toption.series[0].symbolOffset = [0, -5.5];
                    Toption && TmyChart.setOption(Toption);
                } else if (
                    data.selected[datamap[0]] == false &&
                    data.selected[datamap[1]] == true
                ) {
                    //1不选2选
                    Toption.series[0].data = [];
                    Toption.series[1].data = data2;
                    Toption.series[1].symbolOffset = [0, -5.5];
                    Toption && TmyChart.setOption(Toption);
                } else if (
                    data.selected[datamap[0]] == true &&
                    data.selected[datamap[1]] == true
                ) {
                    //1,2都选
                    Toption.series[0].data = data1;
                    Toption.series[1].data = data2;
                    Toption.series[1].symbolOffset = [17, -5.5];
                    Toption.series[0].symbolOffset = [-17, -5.5];
                    Toption && TmyChart.setOption(Toption);
                }
            });
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.setdata()
        this.DrawEcharts();
    }
};
</script>

<style scoped lang="scss">
.cbg-content {
    height: 600px;
    pointer-events: auto;

    .cbg-top {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        column-gap: 28px;
    }

    .contentCenterTitle {
        font-size: 16px;
        color: #fff;
    }

    .centerNum {
        width: 41px;
        width: 41px;
        height: 54px;
        background: url(../../assets/template/num-bg.png) no-repeat;
        background-size: 100%;
        margin: 4px 6px 0 0;
        font-family: "lcdd";
        font-size: 45px;
        color: #fff;
        line-height: 50px;
        text-align: left;

        span {
            font-family: YeJinShuZi;
            padding-left: 7px;
        }
    }

    .dl {
        display: flex
    }

    .bar_bg {
        width: 1117px;
        height: 180px;
        background: url("../../assets/temimg11/bar_bg.png") no-repeat center center;
        background-size: 100% 100%;
        position: absolute;
        bottom: 0;
        left: calc(50% - 558.5px);
    }

    .lt-left {
        width: 357px;
        height: 358px;
        position: absolute;
        left: calc(49.5% - 371px);
        top: calc(50% - 159px);
        box-sizing: border-box;
        background: url("../../assets/temimg11/bar_cen.png") no-repeat;
        background-size: 100%;
    }

    .cmain {
        width: 95%;
        height: calc(100% - 200px);
        margin: 0 auto;
    }

    .center_text {
        position: absolute;
        top: 54%;
        left: 29%;
        transform: translate(-50%, -50%);
        text-align: center;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 41px;
        color: #ffffff;
        line-height: 48px;

        span {
            max-width: 140px;
            display: block;
            white-space: nowrap;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 21px;
            color: #ffffff;
            line-height: 48px;
        }
    }
}
</style>